/**
 * Inspection model translations
 *
 * Translation keys follow the pattern: models.inspection.{category}.{key}
 * Categories: fields, tabs, blocks, badges, actions, filters, options
 */
export default {
  en: {
    singular: "Inspection",
    plural: "Inspections",

    tabs: {
      general: "General",
      report: "Report",
      app_data: "Custom Data",
    },

    blocks: {
      identity: "Inspection Details",
      relationships: "People & Context",
      scoring: "Scoring",
      report_data: "Report Data",
      custom_data: "App-Specific Data",
    },

    fields: {
      type: "Type",
      inspection_date: "Inspection Date",
      status: "Status",
      score: "Score",
      version: "Version",
      problem_count: "Problems",
      client_id: "Client",
      employee_id: "Employee",
      supervisor_id: "Supervisor",
      schedule_id: "Schedule",
      report: "Report",
      app_data: "App Data",
      created_at: "Created At",
      updated_at: "Updated At",
      client: {
        name: "Client",
      },
      employee: {
        full_name: "Employee",
      },
      supervisor: {
        full_name: "Supervisor",
      },
    },

    badges: {
      // Type
      inspection: "Inspection",
      coaching: "Coaching",
      satisfaction: "Satisfaction",
      // Status
      draft: "Draft",
      submitted: "Submitted",
    },

    filters: {
      type: "Type",
      status: "Status",
      client_id: "Client",
      supervisor_id: "Supervisor",
      employee_id: "Employee",
      inspection_date: "Period",
    },

    options: {
      type: {
        inspection: "Inspection",
        coaching: "Coaching",
        satisfaction: "Satisfaction",
      },
      status: {
        draft: "Draft",
        submitted: "Submitted",
      },
    },

    actions: {
      inspections: "Inspections",
    },
  },

  fr: {
    singular: "Inspection",
    plural: "Inspections",

    tabs: {
      general: "Général",
      report: "Rapport",
      app_data: "Données personnalisées",
    },

    blocks: {
      identity: "Détails de l'inspection",
      relationships: "Personnes et contexte",
      scoring: "Pointage",
      report_data: "Données du rapport",
      custom_data: "Données spécifiques",
    },

    fields: {
      type: "Type",
      inspection_date: "Date d'inspection",
      status: "Statut",
      score: "Pointage",
      version: "Version",
      problem_count: "Problèmes",
      client_id: "Client",
      employee_id: "Employé",
      supervisor_id: "Superviseur",
      schedule_id: "Horaire",
      report: "Rapport",
      app_data: "Données d'application",
      created_at: "Créé le",
      updated_at: "Modifié le",
      client: {
        name: "Client",
      },
      employee: {
        full_name: "Employé",
      },
      supervisor: {
        full_name: "Superviseur",
      },
    },

    badges: {
      // Type
      inspection: "Inspection",
      coaching: "Coaching",
      satisfaction: "Satisfaction",
      // Status
      draft: "Brouillon",
      submitted: "Soumis",
    },

    filters: {
      type: "Type",
      status: "Statut",
      client_id: "Client",
      supervisor_id: "Superviseur",
      employee_id: "Employé",
      inspection_date: "Période",
    },

    options: {
      type: {
        inspection: "Inspection",
        coaching: "Coaching",
        satisfaction: "Satisfaction",
      },
      status: {
        draft: "Brouillon",
        submitted: "Soumis",
      },
    },

    actions: {
      inspections: "Inspections",
    },
  },
};
